<template>
    <div class="flex" :data-cy="$attrs['data-cy'] || 'input_simple_checkbox'">
        <div>
            <div class="w-6 h-6 border-2 border-blue-500 rounded-full flex justify-center items-center cursor-pointer"
                 @click="toggleCheck()"
                 data-cy="btn_checkbox_toggle">
                <div v-if="check" class="w-4 h-4 bg-blue-500 rounded-full" data-cy="icon_checkbox_indicator"></div>
            </div>
        </div>
        <div class="pl-2" v-html="text" data-cy="text_checkbox_label"></div>
    </div>
</template>
<script>
export default {
    name: "Checkbox",
    props: {
        check: { type: Boolean }, // v-model:check
        text: { type: String, required: true },
    },
    methods: {
        toggleCheck: function() {
            let value = !this.check;
            this.$emit('update:check', value);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
